<template>
  <div class="app flex-row align-items-center" id="forgot-page">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h3 class="text-center">Quên mật khẩu</h3>
                <b-alert
                  variant="danger"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlert"
                  @dismissed="mData.dataDefault.showDismissibleAlert = false"
                  style="white-space: pre-wrap"
                  >{{ mData.dataDefault.error }}</b-alert
                >
                <b-alert
                  variant="success"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlertSuccess"
                  @dismissed="
                    mData.dataDefault.showDismissibleAlertSuccess = false
                  "
                  >{{ mData.dataDefault.success }}</b-alert
                >

                <el-form
                  :model="mData.dataForm"
                  :rules="mData.validForm"
                  ref="myForm"
                  label-width="100%"
                  label-position="top"
                  @submit.native.prevent
                >
                  <el-form-item
                    label="Nhập Số điện thoại/Email để lấy lại mật khẩu"
                    prop="account"
                  >
                    <el-input
                      prefix-icon="el-icon-user"
                      v-model.trim="mData.dataForm.account"
                      clearable
                    ></el-input>
                  </el-form-item>

                  <el-form-item class="text-center mt-4">
                    <el-button
                      type="primary"
                      @click="fn_submitForm()"
                      v-ladda
                      native-type="submit"
                      >Gửi mã khôi phục</el-button
                    >
                  </el-form-item>
                </el-form>
                <b-col md="12" class="text-center">
                  <b-link to="/auth/login">Quay lại trang đăng nhập</b-link>
                </b-col>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
    <el-dialog
      class="dialog-list-account"
      title="Chọn tài khoản bạn muốn lấy lại mật khẩu"
      :visible.sync="dialogVisible"
      width="450px"
      :before-close="dialogBeforeClose"
      :close-on-click-modal="false"
    >
      <div>
        <!-- <el-radio-group v-model="accountChooseFromDialog">
          <b-row>
            <b-col md="6" v-for="(item, index) in listAccount" :key="index">
              <el-radio :label="item.Account">
                {{ item.Account }} - {{ item.Ho_ten }}
              </el-radio>
            </b-col>
          </b-row>
        </el-radio-group> -->
        <b-row>
          <b-col md="12" v-for="item in listAccount" :key="item.Account">
            <div
              :class="{
                'list-account__item': true,
                'active': item.Account === accountChooseFromDialog
              }" @click="fn_selectAccount(item)">
              {{ item.Account }} - {{ item.Ho_ten }}
            </div>
          </b-col>
        </b-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="changePass(accountChooseFromDialog)"
          :disabled="!accountChooseFromDialog"
        >
          Chọn
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AuthService from "../../service/AuthService";
import LanguageService from "../../service/LanguageService";
import ValidService from "../../service/ValidService";
import MethodService from "../../service/MethodService";
import mushroomDulich from "../../service/api/dulich-api";
export default {
  data() {
    let validateField = (rule, value, callback) => {
      if (!MethodService.checkEmailOrPhone(value)) {
        callback(new Error("Tài khoản là số điện thoại hoặc email"));
      } else {
        callback();
      }
    };
    return {
      aLang: LanguageService.lang,
      mData: {
        dataDefault: {
          error: "",
          showDismissibleAlert: false,
          success: "",
          showDismissibleAlertSuccess: false,
        },
        dataForm: {
          account: "",
        },
        validForm: {
          account: [
            ValidService.required,
            { validator: validateField, trigger: "change" },
          ],
        },
      },
      accountChooseFromDialog: undefined,
      dialogVisible: false,
      listAccount: [],
    };
  },
  methods: {
    fn_selectAccount(item) {
      this.accountChooseFromDialog = item.Account
    },
    fn_submitForm() {
      this.$refs["myForm"].validate((valid) => {
        if (valid) {
          mushroomDulich.user.getAccountByPhoneOrEmailAsync({
            body: {
              phoneOrEmail: this.mData.dataForm.account,
              nguon: "trang_vang",
            }
          })
            .then(async (res) => {
              if (res.result && res.result.length == 1) {
                this.changePass(res.result[0].Account);
              } else if (res.result && res.result.length > 0) {
                this.listAccount = res.result;
                this.dialogVisible = true;
                MethodService.stopLadda()
              } else {
                this.mData.dataDefault.showDismissibleAlert = true;
                if (!MethodService.checkEmailOrPhone(this.mData.dataForm.account)) {
                  this.mData.dataDefault.error =
                    "Tài khoản là số điện thoại hoặc email";
                } else {
                  this.mData.dataDefault.error = `Yêu cầu gửi mã khôi phục không thành công! Có thể do một trong các lý do sau:
                - Tài khoản chưa được đăng ký.
                - Tài khoản đã bị khóa.
                - Hoặc do đường truyền internet của bạn đang bị gián đoạn.`;
                }
                MethodService.stopLadda();
              }
            })
            .catch((err) => {
              console.log('err', err)
              this.mData.dataDefault.showDismissibleAlert = true;
              this.mData.dataDefault.error = err.detail;
              console.log('this.mData.dataDefault.error', this.mData.dataDefault.error);
              MethodService.stopLadda()
            });
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    changePass(account) {
      AuthService.recoverPassword(account)
        .then((res) => {
          this.mData.dataDefault.showDismissibleAlertSuccess = true;
          this.mData.dataDefault.success =
            "Bạn hãy kiểm tra email để lấy lại mật khẩu";
          this.$router.push({
            name: "Auth-ResetPassword",
            query: { account: account },
            params: {
              msg: res.result && res.result.msg ? res.result.msg : null,
            },
          });
        })
        .catch(() => {
          this.mData.dataDefault.showDismissibleAlert = true;
          this.mData.dataDefault.error = `Yêu cầu gửi mã khôi phục không thành công! Có thể do một trong các lý do sau:
            - Tài khoản chưa được đăng ký.
            - Tài khoản đã bị khóa.
            - Tài khoản khai báo thiếu thông tin email và số điện thoại.
            - Hoặc do đường truyền internet của bạn đang bị gián đoạn.`;
        });
    },
    dialogBeforeClose(done) {
      this.accountChooseFromDialog = undefined;
      this.listAccount = [];
      done();
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
  },
  mounted() {
    if (this.$router.currentRoute.query.a) {
      this.mData.dataForm.account = this.$router.currentRoute.query.a
    }
  },
};
</script>
<style lang="scss">
.dialog-list-account {
  .el-dialog__header {
    .el-dialog__title {
      font-size: 17px;
    }
  }
  .el-dialog__body {
    padding: 10px;
    .list-account__item {
      word-break: break-word;
      text-align: center;
      font-weight: 600;
      margin: 0 auto;
      padding: 10px 20px;
      color: #212121;
      background-color: #fff;
      border: 1px solid #409eff;
      border-radius: 12px;
      cursor: pointer;
      text-transform: uppercase;
      margin-bottom: 10px;
      &.active {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
      }
      &:hover {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
      }

    }
  }
}
</style>
